import React, { SyntheticEvent } from 'react';
import {
  GridWrapper,
  MarginText,
  MobileCard,
  MobileContent,
  MobileActions
} from './Styled';
import DefaultImage from 'images/empty_states/empty_state_search.png';
import SocialMediaIcon from 'components/icons/SocialMediaIcon';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { BoxActionChallenges } from 'components/boxes/PostPointsBox/StyledPostPointsBox';
import Button from 'components/buttons/Button';

export interface ChallengeAmbassadorCardProps {
  key: number;
  challenge: any;
  timeLine: any;
}

const ChallengeAmbassadorCard: React.FC<ChallengeAmbassadorCardProps> = props => {
  const { key, challenge, timeLine } = props;
  const { t } = useTranslation(['campaign_card', 'challenge']);
  const history = useHistory();
  const socialNetworks = [
    'facebook',
    'twitter',
    'linkedin',
    'instagram',
    'tiktok',
    'snapchat',
    'youtube',
    'threads',
    'others'
  ];

  const addDefaultPicture = (evt: SyntheticEvent<HTMLImageElement, Event>) => {
    evt.currentTarget.src = DefaultImage;
  };

  return (
    <>
      {/* Versión Desktop */}
      <GridWrapper key={key} className="hide-on-mobile hoverable small">
        <div className="content-box-header content-img">
          <img
            alt={challenge.name}
            className="image-label"
            onError={evt => addDefaultPicture(evt)}
            src={challenge.photo || DefaultImage}
          />
        </div>
        <MarginText className="m-auto">
          <p className="time-line">
            {timeLine(challenge.startDate, challenge.finishDate)}
          </p>
          <div>
            <h2>{challenge.name}</h2>
          </div>
          <div>
            <span className="subtitle">{`${t('challenge:rules')}: `}</span>
            <span>{`${t(`${challenge.content}`)}`}</span>
          </div>
          <p className="social-networks">
            <span className="subtitle">{`${t(
              'challenge:social_networks'
            )}: `}</span>
            {socialNetworks.map((network, index) => {
              return (
                challenge[network] && (
                  <SocialMediaIcon
                    key={index}
                    name={network === 'others' ? 'otros' : network}
                    size="small"
                    shape="square"
                  />
                )
              );
            })}
            <div>
              <span className="format subtitle">
                {`${t('challenge:format')}: `}
              </span>
              <span>
                {challenge.format === 'video, image'
                  ? `${t('challenge:image')} ${t('challenge:and')} ${t(
                      'challenge:video'
                    )}`
                  : `${t(`challenge:${challenge.format}`)}`}
              </span>
            </div>
          </p>
        </MarginText>
        <BoxActionChallenges>
          <Button
            value={t('challenge:participate')}
            variant="primary"
            onClick={() =>
              history.replace({
                pathname: `/challenges/detail/${challenge.id}`
              })
            }
            as="a"
            size="medium"
          />
        </BoxActionChallenges>
      </GridWrapper>

      {/* Versión Mobile */}
      <MobileCard key={`mobile-${key}`} className="show-on-mobile">
        <MobileContent>
          <div className="mobile-header">
            <img
              alt={challenge.name}
              className="mobile-image"
              onError={evt => addDefaultPicture(evt)}
              src={challenge.photo || DefaultImage}
            />
            <div className="mobile-title-section">
              <p className="mobile-time-line">
                {timeLine(challenge.startDate, challenge.finishDate)}
              </p>
              <h2 className="mobile-title">{challenge.name}</h2>
              <div className="mobile-social-section">
                <div className="mobile-social-icons">
                  {socialNetworks.map((network, index) => {
                    return (
                      challenge[network] && (
                        <SocialMediaIcon
                          key={index}
                          name={network === 'others' ? 'otros' : network}
                          size="small"
                          shape="square"
                        />
                      )
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="mobile-details">
            <div className="mobile-rules">
              <span className="mobile-subtitle">{`${t(
                'challenge:rules'
              )}: `}</span>
              <span className="mobile-text">{`${t(
                `${challenge.content}`
              )}`}</span>
            </div>
          </div>
        </MobileContent>

        <MobileActions>
          <Button
            value={t('challenge:participate')}
            variant="primary"
            onClick={() =>
              history.replace({
                pathname: `/challenges/detail/${challenge.id}`
              })
            }
            as="a"
            size="medium"
            className="mobile-button"
          />
        </MobileActions>
      </MobileCard>
    </>
  );
};

export default ChallengeAmbassadorCard;
